/**
 * Avatar background colours for initials avatars (ClientPortal logins).
 *
 * Mirrors PortalUser::AVATAR_PALETTE in PHP — keep both in sync. Values come from
 * scss/utilities/colors.scss but are hardcoded on purpose: an explicitly chosen
 * colour is persisted per user and must not drift when the theme changes. All eight
 * carry white text at >= 4.5:1, which is why the yellow/orange variants are absent.
 */
export const AVATAR_COLORS = [
    '#3C8DBC', // blue-light
    '#41B883', // ocean-green
    '#995AB1', // purple
    '#60A4AB', // turqoise
    '#9F4C0F', // brown
    '#34495E', // blue-dark
    '#663399', // lila
    '#E68C87', // pink-dark
];

/**
 * Deterministic fallback when no colour is stored. Uses the same CRC32 the backend
 * uses, so a value computed here matches PortalUser::deriveAvatarColor() for the
 * same seed and the avatar does not change colour once the server answers.
 */
export const avatarColorFor = function (seed) {
    return AVATAR_COLORS[crc32(String(seed || '').trim().toLowerCase()) % AVATAR_COLORS.length];
};

let crcTable = null;

function buildCrcTable() {
    const table = new Array(256);
    for (let n = 0; n < 256; n++) {
        let c = n;
        for (let k = 0; k < 8; k++) {
            c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1;
        }
        table[n] = c >>> 0;
    }
    return table;
}

/** CRC32 (IEEE 802.3), matching PHP's crc32(). */
function crc32(input) {
    if (!crcTable) {
        crcTable = buildCrcTable();
    }

    // Hash the UTF-8 bytes, like PHP does — otherwise "Müller" would differ per side.
    const bytes = new TextEncoder().encode(input);
    let crc = 0xFFFFFFFF;
    for (let i = 0; i < bytes.length; i++) {
        crc = crcTable[(crc ^ bytes[i]) & 0xFF] ^ (crc >>> 8);
    }

    return (crc ^ 0xFFFFFFFF) >>> 0;
}
